<template>
    <div>
        <Breadcrumbs title="Setting"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="edit-profile">
              <div class="row">
                <div class="col-xl-3">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="card-title mb-0">My Profile</h4>
                      <div class="card-options"><a class="card-options-collapse" href="#" data-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="#" data-toggle="card-remove"><i class="fe fe-x"></i></a></div>
                    </div>
                    <div class="card-body">
                      <form>
                        <div class="row mb-2">
                          <div class="col-auto"><img class="img-70 rounded-" alt="" 
                          :src="mainUser.logo ? mainUser.logo : require('../assets/images/dashboard/prof.png')"
                          ></div>
                          <div class="col">
                            <h4 class="mb-1">{{ mainUser.name }}</h4>
                            <span class="mb-0"><a :href="`tel:${mainUser.phone.countryCode+mainUser.phone.tel}`" target="_blank">{{ mainUser.phone.countryCode+mainUser.phone.tel }}</a></span>
                            <p class="mb-4" style="font-weight: 500;">{{ mainUser.type ? mainUser.type : 'Admin' }}</p>
                            <!-- <p class="mb-3"><a v-b-tooltip.hover :class="`btn btn-primary btn-xs  mr-3`">
                                      {{ mainUser.type ? mainUser.type : 'Admin' }}
                                    </a></p> -->
                          </div>
                        </div>
                        <div v-if="mainUser.categories" class="form-group">
                          <h6 class="form-label">Categories</h6>
                          <!-- <textarea class="form-control" rows="5" :value="mainUser.categories.join(',')"></textarea> -->
                          <span v-for="cat in mainUser.categories" :key="cat" v-b-tooltip.hover :class="`btn btn-primary btn-xs btn-pill mr-2 mb-2`">
                                      {{ cat }}
                                    </span>
                        </div>
                        <div class="form-group">
                          <h6 class="form-label">Address</h6>
                          <!-- <label class="form-label">Email-Address</label> -->
                          <!-- <input class="form-control" :value="mainUser.email" placeholder="your-email@domain.com"> -->
                          <p>{{  mainUser.locationName }}</p>
                        </div>
                        <div class="form-group">
                          <h6 class="form-label">Email</h6>
                          <!-- <label class="form-label">Email-Address</label> -->
                          <!-- <input class="form-control" :value="mainUser.email" placeholder="your-email@domain.com"> -->
                          <p>{{  mainUser.email }}</p>
                        </div>
                        <div v-if="mainUser.website" class="form-group">
                          <!-- <label class="form-label">Website</label> -->
                          <h6 class="form-label">Website</h6>
                          <!-- <input class="form-control" placeholder="website" :value="mainUser.website"> -->
                          <p> <a :href="mainUser.website" target="_blank">{{  mainUser.website }}</a></p>
                        </div>
                        <div v-if="mainUser.smsSender" class="form-group">
                          <!-- <label class="form-label">Website</label> -->
                          <h6 class="form-label">SMS Sender </h6>
                          <!-- <input class="form-control" placeholder="website" :value="mainUser.website"> -->
                          <p> {{  mainUser.smsSender.sender }} <a v-b-tooltip.hover title="Sms sender status" :class="`btn ${ (senderApproved ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (senderApproved ? 'Approved' : 'Not approved') }}
                                    </a></p>
                        </div>
                        <!-- <div class="form-group">
                          <label class="form-label">Password</label>
                          <input class="form-control" type="password" placeholder="password" value="">
                        </div>
                        <div class="form-footer">
                          <button class="btn btn-primary btn-block">Save</button>
                        </div> -->
                      </form>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6">
                  <form class="card">
                    <div class="card-header">
                      <h4 class="card-title mb-0">Edit Profile</h4>
                      <div class="card-options"><a class="card-options-collapse" href="#" data-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="#" data-toggle="card-remove"><i class="fe fe-x"></i></a></div>
                    </div>
                    <div class="card-body">

                      <h5 class="py-2">Sms setting</h5>
                      <div class="row">
                        <!-- {{ sms }} -->
                        <div class="col-sm-6 col-md-2">
                          <div class="form-group">
                            <label class="form-label"> Sender name</label>
                            <input :disabled="mainUser.smsSender && mainUser.smsSender.approved" maxlength="11" class="form-control" type="text" placeholder="Sender name" v-model="sender">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-2">
                          <!-- <div class="form-group"> -->
                            <label class="form-label">Status</label>
                            <!-- <input class="form-control" type="text" placeholder="Username"> -->
                            <br>
                            <a v-b-tooltip.hover title="Sms sender status" :class="`btn ${ (senderApproved ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (senderApproved ? 'Approved' : 'Not approved') }}
                                    </a>
                          <!-- </div> -->
                        </div>
                        <div class="col-sm-6 col-md-2">
                          <button class="btn btn-primary mt-4" type="button" :disabled="mainUser.smsSender && mainUser.smsSender.approved || !sender" @click="saveSender"> Submit</button >
                          <!-- <div class="form-group">
                            <label class="form-label">Email address</label>
                            <input class="form-control" type="email" placeholder="Email">
                          </div> -->
                        </div>
                        <div class="col-sm-6 col-md-2">
                          <div class="form-group">
                            <label class="form-label">Sms Total </label>
                            <input :disabled="true" maxlength="11" class="form-control" type="text" placeholder="Sender name" :value="sms.total">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-2">
                          <div class="form-group">
                            <label class="form-label">Sms Used </label>
                            <input :disabled="true" maxlength="11" class="form-control" type="text" placeholder="Sender name" :value="sms.used">
                          </div>
                        </div>
                        <!-- <div class="col-sm-6 col-md-2">
                          <div class="form-group">
                            <label class="form-label">Sms Available </label>
                            <input :disabled="true" maxlength="11" class="form-control" type="text" placeholder="Sender name" :value="sms.total - sms.used">
                          </div>
                        </div> -->
                        <div class="col-sm-6 col-md-2">
                          <button class="btn btn-primary mt-4" type="button" > Purchase</button >
                          <!-- <div class="form-group">
                            <label class="form-label">Email address</label>
                            <input class="form-control" type="email" placeholder="Email">
                          </div> -->
                        </div>
                      </div>
                      
                      <h5 class="py-2">Main setting</h5>
                      <div class="row">
                        <div class="col-sm-4 col-md-4">
                          <div class="form-group">
                            <label class="form-label">Email</label>
                            <b-form-input class="form-control" type="email" placeholder="Email Address" v-model="mainUser.email"></b-form-input>
                          </div>
                        </div>
                        <div class="col-sm-4 col-md-4">
                          <div class="form-group">
                            <label class="form-label">Website</label>
                            <b-form-input class="form-control" type="website" placeholder="Website"  v-model="mainUser.website"></b-form-input>
                          </div>
                        </div>
                        <div class="col-sm-4 col-md-4">
                          <div class="form-group">
                            <label class="form-label">Type</label>
                            <b-form-input class="form-control" type="text" placeholder="Website"  v-model="mainUser.type"></b-form-input>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-0">
                            <label class="form-label">Categories</label>
                            <!-- <textarea class="form-control" rows="5" placeholder="Enter About your description"></textarea> -->
                            
                          <textarea class="form-control" rows="5" :value="mainUser.categories.join(',')"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer text-right">
                      <button class="btn btn-primary" type="submit">Update Profile</button>
                    </div>
                  </form>
                </div>
                
                <div class="col-xl-3">
                  <form class="card">
                    <div class="card-header">
                      <h4 class="card-title mb-0">Change Password</h4>
                      <div class="card-options"><a class="card-options-collapse" href="#" data-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="#" data-toggle="card-remove"><i class="fe fe-x"></i></a></div>
                    </div>
                    <div class="card-body">

                      <h5 class="pb-2">Password</h5>
                      <!-- <div class="row"> -->
                        <!-- <div class="col-sm-5 col-md-5"> -->
                          <div class="form-group">
                            <label class="form-label">Former Password</label>
                            <input class="form-control" type="password" v-model="ops" placeholder="Enter password">
                          </div>
                        <!-- </div> -->
                        <!-- <div class="col-sm-5 col-md-5"> -->
                          <div class="form-group">
                            <label class="form-label">New Password</label>
                            <input class="form-control" type="password" v-model="ps" placeholder="Enter password">
                          </div>
                          <p class="txt-danger" v-if="(ops || ps) && ops == ps">Both passwords are the same.</p>
                        <!-- </div> -->
                        <div class="">
                          <button class="btn btn-primary btn-block mt-4" type="button" :disabled="!ops || !ps" @click="saveSender"> Submit</button >
                        </div>
                      <!-- </div> -->
                    </div>
                    </form>
                </div>

                
              </div>
            </div>
          </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>

import { mapState } from "vuex";
import axios from "axios"

export default {
  name: 'SettingPage',
  data() {
    return {
      sender: '',
      senderApproved: false,
      sms: {},
      ops: '',
      ps: ''
    }
  },
  computed: {
    ...mapState({
      mainUser: (state) => state.authentication.user,
    }),
  },
  mounted() {
    this.getSender()

    if (this.mainUser.smsSender) {
      this.sender = this.mainUser.smsSender.sender
      this.sender = this.mainUser.smsSender.sender
    }
  },
  methods: {
    saveSender() {
      //
      axios.post('/shop/sms/sender', { shop: this.mainUser.name, sender: this.sender }).then(response=> {

            this.$swal({
              title:"Good job!",
              text: response.data,
              type:'success'
            });

         this.getSender()
        //
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    getSender() {
      //
      axios.get('/shop/sms/sender?shop='+this.mainUser.name).then(response=> {

          //
          this.senderApproved = response.data.smsSender.approved
          this.sender = response.data.smsSender.sender
          this.sms = response.data.sms
         
        //
        
      }).catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
      

    },
  }
}
</script>